import React, { useEffect, useState ,useContext} from "react";
import "./CustomerFormStyle.css";
import logo from "./yes.png";
import { useSearchParams } from "react-router-dom";
import { onecodeAPI } from "../AppConfig";
import { AiOutlineRight } from "react-icons/ai";
import { fontSize } from "@mui/system";
import recommended from "./recommend.png";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { Context } from "../App";

export default function AgentDetails({
  setCustomer,
  setLoading,
  setOnecode,
  currentScreen = 5,
  loading,
  recommendationFlow = false,
  brandSpecific,
  setBrandSpecific,
}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [profilePicUrl, setProfileUrl] = useState("");
  const [partnerDetails, setPartnerDetails] = useState("");
  const [subAgentName, setSubAgentName] = useState("");
  const { t } = useTranslation();
  const consumer = useContext(Context);
  // const [brandSpecific, setBrandSpecific] = useState(false);

  useEffect(() => {
    getAgentDetails();
  }, [searchParams]);

  const getAgentDetails = async () => {
    try {
      setLoading(true);
      let hash = encodeURIComponent(searchParams.get("hash"));
      const res = await onecodeAPI.post("public/customer/getAgentDetails", {
        hash: hash,
      });
      // console.log("agent details response", res);
      const {
        data: {
          result: {
            customer,
            email,
            fullName,
            profilePicUrl,
            onecode,
            brandComms,
            subAgentName,
          },
        },
      } = res;
      // let subAgentName = "Ankush";
      setTimeout(() => {
        window?.Moengage?.add_unique_user_id(onecode);
        setOnecode(onecode);
      }, 1000);
      // setPartnerDetails(partnerDetailsData);
      if (!_.isEmpty(brandComms)) {
        const comms = JSON.parse(res.data?.result?.brandComms?.en);
        const attributionType = res.data?.result?.brandComms?.attributionType;
        setPartnerDetails(comms);
        sessionStorage.setItem("partnerDetails", JSON.stringify(comms));
        sessionStorage.setItem("attributionType", attributionType);
        setBrandSpecific(true);
      }
      if (subAgentName != null) {
        setSubAgentName(subAgentName);
        consumer.setIsMyTeamsFlow(true);
      } else {
        setName(fullName);
        setEmail(email);
        setProfileUrl(profilePicUrl);
      }
      if (customer != null) {
        setCustomer(customer);
      }
      setLoading(false);
    } catch (e) {
      console.log("error fetching data", e);
    }
  };

  const openDetailFile = () => {
    let filePath = partnerDetails?.partnerPdf;
    window.open(filePath, "_blank");
  };
// console.log(consumer,"consumer=====")
  return (
    <>
      {recommendationFlow && brandSpecific ? (
        <></>
      ) : (
        <div className={brandSpecific ? "" : "agentDetails"}>
          <div className={brandSpecific ? "" : "agentDetailsTopContainer"}>
            {!loading ? (
              !brandSpecific ? (
                <div className="agentPicContainer">
                  {!subAgentName ? (
                    <img src={profilePicUrl} alt="avatar" />
                  ) : (
                    <div className="subAgentPicContainer" style={{justifyContent: "center",alignItems:"center"}}>
                      <p style={{ textAlign: "center",fontSize:"20px",color:"white",marginTop:"15px" }}>{subAgentName.split("")[0]}</p>
                    </div>
                  )}
                  <div>
                    <div className="agentTitle">
                      {t("recommendation.Businessconsultant")}
                    </div>
                    <div
                      style={{
                        color: "#000000",
                        fontWeight: "500",
                        fontSize: "16px",
                      }}
                    >
                      {subAgentName ? subAgentName : name}
                    </div>
                    <div className="agentTitle">{email}</div>
                  </div>
                </div>
              ) : (
                <div
                  onClick={() => {
                    window?.Moengage?.track_event(
                      "mycustomers-brand_customer_know_more"
                    );
                    if (partnerDetails?.partnerPdf) openDetailFile();
                  }}
                  style={{
                    display: "flex",
                    margin: "0 auto",
                    marginLeft: "3.5%",
                    marginRight: "3.5%",
                    overflow: "hidden",
                    borderRadius: "10px",
                  }}
                >
                  {/* <div className="knowMoreContainer">
                    <img
                      alt=""
                      src={
                        // `https://onecode-asset.s3.ap-south-1.amazonaws.com/LOGOS_PNG/126.png`
                        `https://onecode-asset.s3.ap-south-1.amazonaws.com/LOGOS_PNG/${partnerDetails?.id}.png`
                        `https://onecode-asset.s3.ap-south-1.amazonaws.com/Dhani_Brand_Banner.png`
                      }
                      // src={partnerDetails?.logoUrl}
                      style={{
                        width: "5rem",
                        // border:"1px solid red"
                      }}
                    />
                    <>
                      {partnerDetails?.partnerPdf ? (
                        <div
                          className="knowMoreButton"
                          onClick={() => {
                            window?.Moengage?.track_event("mycustomers-brand_customer_know_more");
                            openDetailFile();
                          }}
                        >
                          Know more
                          <AiOutlineRight />
                        </div>
                      ) : (
                        <></>
                      )}
                    </>
                  </div> */}

                  {partnerDetails?.id ? (
                    <img
                      alt=""
                      src={`https://onecode-asset.s3.ap-south-1.amazonaws.com/Brand_Banners/${partnerDetails?.id}.png`}
                      style={{
                        width: "100%",
                      }}
                    />
                  ) : (
                    <></>
                  )}
                  {/* <div
                    style={{
                      color: "#484848",
                      fontSize: "18px",
                      // paddingLeft:"10px",
                      // margin:"auto",
                      // border:"1px solid red",
                      textAlign: "left",
                      marginTop:"-10px"
                    }}
                  >
                    {/* {partnerDetails?.title} */}
                  {/* </div> */}
                </div>
              )
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
    </>
  );
}
